import axios from "axios";
import { TypeOptions } from "react-toastify";
import { SERVER_URL } from "../config";
import {
  BundleType,
  CollectionApiResultType,
  CollectionType,
  NftDataType,
  OverlayType,
  PriceType,
  TokenType,
  TraitType,
} from "./types";
import { Overlay } from "./types/overlays";
import { prisma } from "./prisma";

export const adminLogin = async (
  username: string,
  password: string
): Promise<any> => {
  try {
    let result = await axios.post(SERVER_URL + "/api/checkAdmin", {
      username,
      password,
    });
    if (result.status == 200 && result.data) {
      return {
        result: true,
        msg: "Login successful",
        data: result.data, // wallet address comes in here incapsulated in the data
      };
    } else {
      return {
        result: false,
        msg: "Login failed",
      };
    }
  } catch (e) {
    console.log(" api error on admin login: ", e);
    return {
      result: false,
      msg: "Api exception",
    };
  }
};

export const checkPriceAvailable = async (priceId: number) => {
  try {
    let response = await axios.post(SERVER_URL + "/api/checkPriceAvailable", {
      id: priceId,
    });
    return {
      result:
        response.status < 300 && response.data ? response.data.result : false,
      data:
        response.status < 300 && response.data
          ? response.data.data
          : "Connection Exception",
    };
  } catch (e) {
    console.log("err on checkPriceAvailable ", e);
    return {
      result: false,
      data: "Connection Exception",
    };
  }
};
export const purchaseTraitByApi = async (
  wallet: string,
  price: PriceType,
  txId: string,
  mint: string,
  stopPageLoading: () => void,
  toast: (msg: string, type: TypeOptions) => void,
  getPrices: () => void
) => {
  try {
    //console.log("price ", price)
    //console.log(" tx ",txId)
    //console.log(" mint ", mint )
    let result = await axios.post(SERVER_URL + "/api/purchaseTrait", {
      wallet,
      id: price.id,
      txId,
      mint,
    });
    console.log(" api result ", result);
    if (result.status < 300 && result.data) {
      getPrices();

      return result.data;
    } else {
      toast(result.data.data ?? "Operation Failed. ❌", "error");
      stopPageLoading();
      return null;
    }
  } catch (e) {
    console.log("err on purchaseTraitByApi", e);
    stopPageLoading();
    toast("Api Exception", "error");
  }
};

/**
 *
 * @param pid number
 */

export const editListedPriceByid = async (pid: number) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/editListedPrice", {
      id: pid,
    });
    return {
      result: result.status < 300 && result.data ? result.data.result : false,
      data:
        result.status < 300 && result.data
          ? (result.data.data as PriceType[] | string)
          : "Api exception",
    };
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api exception",
    };
  }
};

export const removeListedPriceByid = async (pid: number) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/removeListedPrice", {
      id: pid,
    });
    return {
      result: result.status < 300 && result.data ? result.data.result : false,
      data:
        result.status < 300 && result.data
          ? (result.data.data as PriceType[] | string)
          : "Api exception",
    };
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api exception",
    };
  }
};

export const getAllPrices = async () => {
  try {
    let result = await axios.get(SERVER_URL + "/api/getAll/getAllPrices");
    //console.log("Response Data GetPrices:", result.data.data);

    if (result.status < 300) {
      return result.data.data as PriceType[];
    } else {
      return [];
    }
  } catch (e) {
    console.log("err on getAllPrices ", e);
    return [];
  }
};

/**
 * set price of trait to list
 * @param traitId number
 * @param tokenId number
 * @param price number
 * @param items number
 */

export const editListedPrice = async (
  traitId: number,
  tokenId: number,
  price: number,
  items: number
) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/editListedPrice", {
      traitId,
      tokenId,
      price,
      items,
    });

    return {
      result: result.status < 300 && result.data ? result.data.result : false,
      data:
        result.status < 300 && result.data
          ? (result.data.data as PriceType[] | string)
          : "Api exception",
    };
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api Error",
    };
  }
};

export const listTrait = async (
  traitId: number,
  tokenId: number,
  price: number,
  items: number,
  traitRequirements: any[],
  burnBoobie: boolean
) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/listTrait", {
      traitId,
      tokenId,
      price,
      items,
      traitRequirements,
      burnRequirement: burnBoobie,
    });

    return {
      result: result.status < 300 && result.data ? result.data.result : false,
      data:
        result.status < 300 && result.data
          ? (result.data.data as PriceType[] | string)
          : "Api exception",
    };
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api Error",
    };
  }
};

export const removeTrait = async (tid: number) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/removeTrait", { id: tid });
    return {
      result:
        result.status < 300 && result.data
          ? (result.data.result as boolean)
          : false,
      data:
        result.status < 300 && result.data ? result.data.data : "Api exception",
      //  as {prices: PriceType[], traits: TraitType[]} | string
    };
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api Error!",
    };
  }
};

// Function for Decoding image_URL
interface ModifiedTraitType extends TraitType {
  blob_url: string;
}

export const getAllTraits = async (): Promise<ModifiedTraitType[]> => {
  try {
    const result = await axios.get(SERVER_URL + "/api/getAll/getAllTraits");
    const traits: TraitType[] = result.data.data ?? [];

    // Decode image_url for each trait
    const modifiedTraits: ModifiedTraitType[] = traits?.map((trait) => ({
      ...trait,
      image_url: decodeURIComponent(trait.blob_url),
      unoptimized: true,
    }));

    //console.log(modifiedTraits);
    return modifiedTraits;
  } catch (e) {
    console.log("Error on getAllTraits", e);
    return [];
  }
};

export const uploadTraits = async (fd: FormData) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/addNewTrait", fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        // add any other required headers here
      },
    });
    return {
      result:
        result.data && result.data.result
          ? (result.data.result as boolean)
          : false,
      data:
        result.data && result.data.data
          ? (result.data.data as TraitType[])
          : "Operation Failed",
    };
  } catch (e) {
    console.log("err on uploadTraits ", e);
    return {
      result: false,
      data: "Api Exception Occured!",
    };
  }
};

export const generatePreview = async (
  mint: string,
  type: string,
  id: string
) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/generatePreview", {
      mint: mint,
      type: type,
      id: id,
    });
    //console.log(result.data);
    if (result.status < 300 && result.data.data) {
      return result.data.data as string;
    } else {
      return undefined;
    }
  } catch (e) {
    console.log("err on generatePreview ", e);
    return undefined;
  }
};

export const getAllTokens = async () => {
  try {
    let result = await axios.get(SERVER_URL + "/api/getAll/getAllTokens");
    //console.log("Response Data:", result.data);

    if (result.status < 300) {
      return result.data.data as TokenType[];
    } else {
      return [];
    }
  } catch (e) {
    console.log("err on getAllTokens ", e);
    return [];
  }
};

export const removeToken = async (tid: number) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/removeToken", {
      id: tid,
    });

    return result.data ? (result.data.result as boolean) : false;
  } catch (e) {
    console.log("err on removeToken", e);
    return false;
  }
};

export const addNewToken = async (name: string, address: string) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/add/addNewToken", {
      name,
      address,
    });

    return {
      result:
        result.data && result.data.result
          ? (result.data.result as boolean)
          : false,
      data:
        result.data && result.data.data
          ? (result.data.data as TokenType[])
          : "Operation Failed",
    };
  } catch (e) {
    console.log("err on addNewToken ", e);
    return {
      result: false,
      data: "Api exception orrcured!",
    };
  }
};

export const getAllCollections = async () => {
  try {
    let result = await axios.get(SERVER_URL + "/api/getAll/getAllCollections");
    //console.log("Response Data:", result.data);
    if (result.status < 300) {
      return result.data.data as CollectionType[];
    } else {
      return [];
    }
  } catch (e) {
    console.log("err on getCollectionInfo ", e);
    return [];
  }
};

export const addNewCollection = async (name: string, address: string) => {
  try {
    let result = await axios.post(SERVER_URL + "/api/add/addNewCollection", {
      name,
      address,
    });
    if (result.status < 300 && result.data) {
      return result.data as CollectionApiResultType;
    } else {
      return {
        result: false,
        data: "Operation Failed!",
      };
    }
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api Exception Error Occured!",
    };
  }
};

export const updateCollection = async (collection: CollectionType) => {
  try {
    let result = await axios.post(
      SERVER_URL + "/api/updateCollection",
      collection
    );
    return {
      result: result.data && result.data.result ? result.data.result : false,
      data:
        result.data && result.data.result
          ? result.data.data
          : "Operation Failed",
    };
  } catch (e) {
    console.log(e);
    return {
      result: false,
      data: "Api Exception Error Occured!",
    };
  }
};

export const get_nft_api_rec = async (
  url: string
): Promise<Partial<NftDataType> | undefined> => {
  try {
    const response = await axios.get(url);
    // console.log(response.data.collection.name + '-' + response.status)
    if (response.status == 200) {
      let ColName = "";
      let collectionName = "";
      let familyName = "";
      if (response.data.collection) {
        if (typeof response.data.collection === "string") {
          collectionName = response.data.collection;
        } else if (response.data.collection.name) {
          collectionName = response.data.collection.name;
        }
        if (response.data.collection.family) {
          familyName = response.data.collection.family;
        }
      }

      if (ColName == "") {
        const colArray = response.data.name.split(" #");
        ColName = colArray["0"];
      }

      const nftArray = response.data.name.split("#");
      let nftName = nftArray["1"] ? nftArray["1"] : response.data.name;
      return {
        projectname: ColName ? ColName : "",
        collectionname: collectionName,
        familyname: familyName,
        nftname: nftName,
        image: response.data.image,
        symbol: response.data.symbol,
        attributes: response.data.attributes,
        url: url,
      };
    } else return;
  } catch (error) {
    //console.error(error, "error in get_nft_api_rec");
    return;
  }
};

export const getAllOverlays = async (): Promise<Overlay[]> => {
  const response = await fetch(`${SERVER_URL}/api/getAll/getAllOverlays`);
  const result = await response.json();
  if (!result.result) {
    throw new Error(result.error || "Failed to fetch overlays");
  }

  // Flatten and transform the categorized overlays
  return Object.values(result.data)
    .flat()
    .map((overlay: any) => ({
      ...overlay,
      created_at: new Date(overlay.created_at),
      updated_at: new Date(overlay.updated_at),
    }));
};

export const getLocalAllOverlays = async (): Promise<OverlayType[]> => {
  try {
    const response = await fetch("/api/overlays");
    if (!response.ok) {
      throw new Error("Failed to fetch overlays");
    }
    const data = await response.json();
    console.log("Fetched overlays:", data); // Debug log
    return data;
  } catch (error) {
    console.error("Error fetching overlays:", error);
    throw error;
  }
};

export const uploadOverlay = async (
  formData: FormData
): Promise<{ result: boolean; data: OverlayType | string }> => {
  try {
    let result = await axios.post(SERVER_URL + "/api/uploadOverlay", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return {
      result: result.status < 300 && result.data ? result.data.result : false,
      data:
        result.status < 300 && result.data ? result.data.data : "Api exception",
    };
  } catch (e) {
    console.log("err on uploadOverlay ", e);
    return {
      result: false,
      data: "Api exception",
    };
  }
};

export const deleteOverlay = async (
  id: string
): Promise<{ result: boolean; data: string }> => {
  try {
    let result = await axios.post(SERVER_URL + "/api/deleteOverlay", { id });
    return {
      result: result.status < 300 && result.data ? result.data.result : false,
      data:
        result.status < 300 && result.data ? result.data.data : "Api exception",
    };
  } catch (e) {
    console.log("err on deleteOverlay ", e);
    return {
      result: false,
      data: "Api exception",
    };
  }
};
